export enum VcfsTrialBalanceStatementCategories {
    PL, 
    BS
}